<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    :max-width="`${width}px`"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon flat @click="$emit('cancel')">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom left>
          <v-btn slot="activator" dark icon>
            <v-icon>library_add</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="clientAreaInputDialog = true">
              <v-list-tile-avatar>
                <v-icon>public</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>Area</v-list-tile-title>
              <client-area-input
                :dialog="clientAreaInputDialog"
                title="AREA"
                action="ADD"
                primary_key="id_area"
                primary_field="area"
                @cancel="clientAreaInputDialog = false"
                @submitted="clientAreaInputDialog = false"
              >
              </client-area-input>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn icon :dark="!sameInput" :disabled="sameInput" @click="submit">
          <v-icon>save</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 1000px">
        <v-form>
          <v-text-field
            v-if="dialog"
            autofocus
            append-icon="account_balance"
            type="text"
            v-model="input.client"
            v-validate="'required'"
            name="client"
            data-vv-name="client"
            label="Nama Client"
            data-vv-as="Nama Client"
            :error-messages="errors.collect('client')"
          >
          </v-text-field>
          <v-text-field
            append-icon="pin_drop"
            type="text"
            v-model="input.kab_kota"
            v-validate="''"
            name="kab_kota"
            data-vv-name="kab_kota"
            label="Kab/Kota"
            data-vv-as="Kab/Kota"
            :error-messages="errors.collect('kab_kota')"
          >
          </v-text-field>
          <v-dialog
            v-model="dialogTglGabung"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              append-icon="today"
              type="text"
              readonly
              v-model="input.tgl_gabung"
              v-validate="'required'"
              name="tgl_gabung"
              data-vv-name="tgl_gabung"
              label="Tanggal Gabung"
              data-vv-as="Tanggal Gabung"
              :error-messages="errors.collect('tgl_gabung')"
            >
            </v-text-field>
            <v-date-picker
              v-model="input.tgl_gabung"
              @input="dialogTglGabung = false"
              :max="$moment().format('YYYY-MM-DD')"
              locale="id-id"
            >
            </v-date-picker>
          </v-dialog>
          <v-container grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  append-icon="people"
                  type="number"
                  min="0"
                  v-model="input.jml_karyawan"
                  v-validate="'numeric'"
                  name="jml_karyawan"
                  data-vv-name="jml_karyawan"
                  label="Jumlah Karyawan"
                  data-vv-as="Jumlah Karyawan"
                  :error-messages="errors.collect('jml_karyawan')"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  append-icon="trending_up"
                  type="number"
                  min="0"
                  v-model="input.target_per_tahun"
                  v-validate="'required|numeric'"
                  name="target_per_tahun"
                  data-vv-name="target_per_tahun"
                  label="Target per Tahun"
                  data-vv-as="Target per Tahun"
                  :error-messages="errors.collect('target_per_tahun')"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  append-icon="local_offer"
                  attach
                  item-text="laman"
                  item-value="id_laman"
                  :items="lamanByLaman"
                  v-model="input.id_laman"
                  v-validate="'required'"
                  name="id_laman"
                  data-vv-name="id_laman"
                  label="Business Unit"
                  data-vv-as="Business Unit"
                  :error-messages="errors.collect('id_laman')"
                >
                  <template slot="item" slot-scope="data">
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        data.item.laman
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{
                        data.item.laman_desc
                      }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  append-icon="map"
                  attach
                  item-text="area"
                  item-value="id_area"
                  :items="areaByLaman"
                  v-model="input.id_area"
                  v-validate="'required'"
                  name="id_area"
                  data-vv-name="id_area"
                  label="Area"
                  data-vv-as="Area"
                  :error-messages="errors.collect('id_area')"
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-container>
          <v-select
            append-icon="flash_on"
            attach
            hide-details
            item-text="val"
            item-value="key"
            :items="optionsActiveClient"
            v-model="input.active_client"
            label="Status"
          >
          </v-select>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>


<script>
import _ from "lodash";
import ClientAreaInput from "@/components/pages/input/ClientAreaInput";
import { mapState, mapGetters } from "vuex";

const defaultInput = {
  client: "",
  kab_kota: "",
  tgl_gabung: "",
  jml_karyawan: "",
  target_per_tahun: "",
  id_laman: "",
  id_area: "",
  active_client: "1"
};

export default {
  name: "client-input",
  components: {
    ClientAreaInput
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    primary_field: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      input: _.cloneDeep(defaultInput),
      dataInjected: null,
      dialogTglGabung: false,
      clientAreaInputDialog: false,
      optionsActiveClient: [
        { key: "1", val: "AKTIF" },
        { key: "0", val: "PUTUS" }
      ]
    };
  },
  computed: {
    ...mapState(["status", "id_laman$"]),
    ...mapGetters("area", ["areaByLaman"]),
    ...mapGetters("laman", ["lamanByLaman"]),
    source() {
      return this.$store.state[this.primary_field][this.primary_field];
    },
    titleDialog() {
      let title = this.action == "ADD" ? "TAMBAH" : "EDIT";
      return `${title} ${this.title}`;
    },
    sameInput() {
      return _.isEqual(this.input, this.dataInjected);
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch(
              `${this.primary_field}/${this.action}_${this.title}`,
              this.input
            )
            .then(() => {
              let new_id =
                this.action == "ADD"
                  ? _.last(this.source)[this.primary_key]
                  : null;
              this.$emit("submitted", new_id);
            })
            .catch();
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$validator.reset();
        if (this.action == "ADD") {
          this.dataInjected = _.cloneDeep(defaultInput);
          this.dataInjected.id_laman = this.id_laman$;
        } else {
          this.dataInjected = _.cloneDeep(this.data);
        }
        this.input = _.cloneDeep(this.dataInjected);
      }
    }
  },
  mounted() {
    this.$store.dispatch("client/GET_CLIENT");
    this.$store.dispatch("client/GET_OPTIONS");
  }
};
</script>
